export enum DocumentScopeType {
    LENDER = "LENDER",
    BORROWER = "BORROWER",
    COMMON = "COMMON"
}
